import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

export const ComingSoonGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  let  isRoute: boolean = true;
  let currentDomain = window.origin;
  if (currentDomain === "https://beat22.com") {
    isRoute = true;
  } else {
    isRoute = false;
  }
  return isRoute
};
